export interface IUnderground {
  lineColor: string;
  path: IUndergroundPath;
  stationName: string;
  undergroundType: EUndergroundType;
}

export interface IUndergroundPath {
  pathType: EPathType;
  text: string;
}

export enum EUndergroundType {
  Ekb = 'ekb',
  Kzn = 'kzn',
  Mow = 'mow',
  Nn = 'nn',
  Nsk = 'nsk',
  Smr = 'smr',
  Spb = 'spb',
}

export enum EPathType {
  Walk = 'walk',
  Transport = 'transport',
}
